import * as ChatActions from '@services/chat/chat.actions';
import * as ChatSaga from '@services/chat/chat.saga';
import * as CallsActions from '@services/calls/calls.actions';
import * as CallsSaga from '@services/calls/calls.saga';
import * as CommonActions from '@services/common/common.action';
import * as CommonSaga from '@services/common/common.saga';
import { commonWebSocket } from '@services/common/common.constants';
import * as ScheduleActions from '@services/schedule/schedule.action';
import * as ScheduleSaga from '@services/schedule/schedule.saga';
import * as EventActions from '@services/events/event.action';
import * as EventSaga from '@services/events/event.saga';
import * as TodoActions from '@services/todos/todo.action';
import * as TodoSaga from '@services/todos/todo.saga';
import * as FileActions from '@services/file/file.actions';
import * as FileSaga from '@services/file/file.saga';
import * as SuggestionActions from '@services/suggestion/suggestion.action';
import * as SuggestionSaga from '@services/suggestion/suggestion.saga';
import * as UserActions from '@services/user/user.actions';
import * as UserSaga from '@services/user/user.saga';
import * as FamilyActions from '@services/family/family.actions';
import * as FamilySaga from '@services/family/family.saga';
import * as ArticleSaga from '@services/article/article.saga';
import * as ArticleActions from '@services/article/article.actions';
import * as ExpertSaga from '@services/expert/expert.saga';
import * as ExpertActions from '@services/expert/expert.action';
import * as SharedNoteSaga from '@services/sharednote/sharednote.saga';
import * as SharedNoteActions from '@services/sharednote/sharednote.actions';
import * as ImageFlowSaga from '@services/imageflow/imageflow.saga';
import * as ImageFlowActions from '@services/imageflow/imageflow.actions';
import * as EconomySaga from '@services/economy/economy.saga';
import * as EconomyActions from '@services/economy/economy.actions';
import * as SubscriptionActions from '@services/subscription/subscription.action';
import * as SubscriptionSaga from '@services/subscription/subscription.saga';
import * as RatingActions from '@services/rating/rating.actions';
import * as RatingSaga from '@services/rating/rating.saga';
import * as ExternalCalendarSaga from '@services/externalCalendar/externalCalendar.saga';
import * as ExternalCalendarActions from "@services/externalCalendar/externalCalendar.actions"
import {all, fork, takeEvery, takeLatest} from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    fork(ChatSaga.watchChatHistoryGaps),
    takeLatest(ArticleActions.readArticle, ArticleSaga.readArticle),
    takeLatest(ChatActions.createChat, ChatSaga.createChat),
    takeEvery(ChatActions.createChatMessage, ChatSaga.createChatMessage),
    takeLatest(ChatActions.createChatMessageToxicChecked, ChatSaga.createChatMessageToxicChecked),
    takeLatest(ChatActions.createChatMessageToxicCheckedAction, ChatSaga.createChatMessageToxicCheckedAction),
    takeEvery(ChatActions.chatCheckIn, ChatSaga.chatCheckIn),
    takeLatest(ChatActions.requestChatMessages, ChatSaga.requestChatMessages),
    takeEvery(ChatActions.requestMessageReadInfo, ChatSaga.requestMessageReadInfo),
    takeEvery(ChatActions.sendChatReadReceipt, ChatSaga.sendChatReceipt),
    takeLatest(ChatActions.toxicCheck, ChatSaga.toxicCheck),
    takeLatest(ChatActions.archiveChat, ChatSaga.archiveChat),
    takeLatest(ChatActions.renameChat, ChatSaga.renameChat),
    takeLatest(ChatActions.saveChat, ChatSaga.saveChat),
    takeEvery(FileActions.requestFileUpload, FileSaga.requestFileUpload),
    takeEvery(FileActions.requestChatFileUploadSlot, FileSaga.requestChatFileUploadSlot),
    takeEvery(FileActions.internalUploadFileAfterGivenSlot, FileSaga.internalUploadFileAfterGivenSlot),
    takeEvery(FileActions.uploadSlotRejected, FileSaga.uploadSlotRejected),
    
    takeLatest(EventActions.createEvent, EventSaga.createEvent),
    takeLatest(EventActions.editEvent, EventSaga.editEvent),
    takeLatest(EventActions.deleteEvent, EventSaga.deleteEvent),
    takeEvery(EventActions.seenEvent, EventSaga.seenEvent),
    takeLatest(EventActions.completedEvent, EventSaga.completedEvent),
    takeLatest(EventActions.analyzeImage, EventSaga.analyzeImage),
    takeLatest(EventActions.analyzeReceiptImage, EventSaga.analyzeReceiptImage),
    takeEvery(EventActions.dismissAnalyzedImage, EventSaga.analyzeImageDismiss ),
    takeLatest(EventActions.aiTask, EventSaga.aiTask),
    takeEvery(EventActions.dismissAiTask, EventSaga.dismissAiTask ),
    takeLatest(EventActions.aiScheduleTurn, EventSaga.aiScheduleTurn),
    takeLatest(EventActions.addViewerToEvent, EventSaga.editEventVisibility ),

    takeLatest(ExpertActions.bookChat, ExpertSaga.bookChat),
    takeLatest(ExpertActions.bookMeeting, ExpertSaga.bookMeeting),
    takeLatest(TodoActions.createTodo, TodoSaga.createTodo),
    takeLatest(TodoActions.editTodo, TodoSaga.editTodo),
    takeLatest(TodoActions.deleteTodo, TodoSaga.deleteTodo),
    takeLatest(TodoActions.completeTodo, TodoSaga.completeTodo),
    takeLatest(TodoActions.hideTodo, TodoSaga.hideTodo),
    takeEvery(TodoActions.seenTodo, TodoSaga.seenTodo),

    takeEvery(ExternalCalendarActions.saveExternalCalendar, ExternalCalendarSaga.saveExternalCal),
    takeEvery(ExternalCalendarActions.updateExternalCalendar, ExternalCalendarSaga.updateExternalCal),
    takeLatest(ExternalCalendarActions.deleteExternalCalendar, ExternalCalendarSaga.deleteExternalCalendar),
    takeEvery(ExternalCalendarActions.downloadICSData, ExternalCalendarSaga.downloadICS),
    
    takeLatest(TodoActions.completeHandover, TodoSaga.completeHandover),
    takeLatest(ScheduleActions.createSchedule, ScheduleSaga.createSchedule),
    takeLatest(ScheduleActions.changeScheduleName, ScheduleSaga.changeScheduleName),
    takeLatest(ScheduleActions.changeScheduleSchool, ScheduleSaga.changeScheduleSchool),
    takeLatest(SuggestionActions.createSuggestion, SuggestionSaga.createSuggestion),
    takeLatest(SuggestionActions.respondSuggestion, SuggestionSaga.respondSuggestion),
    takeLatest(SuggestionActions.loadSuggestionHistory, SuggestionSaga.loadSuggestionHistory),
    takeLatest(CommonActions.initWebsocket, CommonSaga.socketSaga),
    takeLatest(CommonActions.bootstrap, CommonSaga.bootstrap),
    takeEvery(commonWebSocket.special.USER_TOKEN_UPDATE, UserSaga.userTokenUpdate),
    takeLatest(UserActions.login, UserSaga.loginUser),
    takeLatest(UserActions.loginMagic, UserSaga.loginMagicUser),
    takeLatest(UserActions.checkServerStatus, UserSaga.checkServerStatus),
    takeLatest(UserActions.reloadResources, UserSaga.reloadResources),
    takeEvery(UserActions.activateEmailAddress, UserSaga.activateEmailAddress),
    fork(UserSaga.watchDeleteGroup),
    takeLatest(UserActions.createUser, UserSaga.signupUser),
    takeLatest(UserActions.getCampaignToken, UserSaga.getCampaignToken),
    takeLatest(UserActions.claimSpecialOffer, UserSaga.claimSpecialOffer),
    takeLatest(FamilyActions.signupAddFamilyMember, FamilySaga.signupAddFamilyMember),
    takeLatest(FamilyActions.signupAddChild, FamilySaga.signupAddChild),
    takeLatest(FamilyActions.selectCountry, FamilySaga.selectFamilyCountry),
    takeLatest(CallsActions.newCall, CallsSaga.newCall),    
    takeLatest(CallsActions.callAction, CallsSaga.callAction),
    takeLatest(CallsActions.allowCalls, CallsSaga.allowCalls),
    takeLatest(CallsActions.callHistory, CallsSaga.callHistory),
    takeLatest(UserActions.forgotPassword, UserSaga.forgotPassword),
    takeLatest(UserActions.reportProblem, UserSaga.reportProblem),
    takeLatest(UserActions.inviteParent, UserSaga.inviteParent),
    takeLatest(UserActions.getInvitedUser, UserSaga.getInvitedUser),
    takeLatest(UserActions.selectFamily, UserSaga.switchFamilySaga),
    takeEvery(UserActions.uploadOfflineEventAnalysis, UserSaga.uploadOfflineEventAnalysis),
    takeLatest(UserActions.storeCampaignToken, UserSaga.storeCampaignToken),
    takeLatest(UserActions.storeInviteToken, UserSaga.storeInviteToken),
    takeLatest(UserActions.signupInvite, UserSaga.signupInvite),
    takeLatest(UserActions.getInviteToken, UserSaga.getInviteToken),
    takeLatest(UserActions.getMunicipality, UserSaga.getMunicipality),
    takeLatest(FamilyActions.addFamilyMember, FamilySaga.addFamilyMember),
    takeLatest(FamilyActions.addUser, FamilySaga.addUser),
    takeLatest(FamilyActions.updateFamilyMember, FamilySaga.updateFamilyMember),
    takeLatest(FamilyActions.updateFamilyMemberFileId, FamilySaga.updateFamilyMemberFileId),
    takeLatest(FamilyActions.createFamily, FamilySaga.createFamily),
    takeLatest(FamilyActions.deleteFamilyMember, FamilySaga.deleteFamilyMember),
    takeLatest(FamilyActions.unlimitFamilyMember, FamilySaga.unlimitFamilyMember),
    takeLatest(FamilyActions.restoreAccount, FamilySaga.restoreAccount),
    takeLatest(FamilyActions.nudgeToLogIn, FamilySaga.nudgeToLogIn),
    takeLatest(FamilyActions.updateChildInfo, FamilySaga.updateChildInfo),
    takeLatest(FamilyActions.enrichFamily, FamilySaga.enrichFamily),

    takeLatest(UserActions.saveHolidayRegion, UserSaga.updateCountry),
    takeLatest(UserActions.updateCalendarSettings, UserSaga.updateCalendarSettings),
    takeEvery(UserActions.updateCalendarSettingsSynch, UserSaga.updateCalendarSettingsSynch),
    takeLatest(UserActions.setOnlyWeeksOf, UserSaga.setOnlyWeeksOf),
    takeEvery(UserActions.updateCalendarSettingsExclude, UserSaga.updateCalendarSettingsExclude),
    takeLatest(UserActions.updateFamilyColors, UserSaga.updateFamilyColors),
    takeLatest(UserActions.updateToxicCheckLevel, UserSaga.toxicCheckLevel),
    takeLatest(UserActions.setAutoApproveSuggestions, UserSaga.autoApproveSuggestions),
    takeLatest(UserActions.setDisablePreviews, UserSaga.disablePreviews),
    takeLatest(UserActions.setDarkMode, UserSaga.darkModeSetting),
    takeEvery(commonWebSocket.replace.DARK_MODE, UserSaga.saveUnsavedDarkMode),
    takeLatest(UserActions.updateAppToken, UserSaga.updateAppToken),
    takeLatest(UserActions.storeLanguage, UserSaga.updateLanguage),
    takeLatest(UserActions.storeDeviceData, UserSaga.updateDeviceData),
    takeLatest(UserActions.changePassword, UserSaga.changePassword),
    takeLatest(UserActions.updateEmail, UserSaga.updateEmail),
    takeLatest(UserActions.eraseAccount, UserSaga.eraseAccount),
    takeLatest(UserActions.logout, UserSaga.logout),
    takeLatest(UserActions.onboarding, UserSaga.onboarding),
    takeLatest(SubscriptionActions.subscribe, SubscriptionSaga.subscribe),
    takeLatest(RatingActions.submitRating, RatingSaga.submitRating),
    takeLatest(RatingActions.requestRatingPrompt, RatingSaga.requestRatingPrompt),
    takeLatest(SharedNoteActions.updateSharedNote, SharedNoteSaga.updateSharedNote),
    takeLatest(SharedNoteActions.deleteSharedNote, SharedNoteSaga.deleteSharedNote),
    takeLatest(SharedNoteActions.seenSharedNote, SharedNoteSaga.seenSharedNote),
    takeLatest(SharedNoteActions.updateSharedNoteOrder, SharedNoteSaga.updateSharedNoteOrder),

    takeLatest(ImageFlowActions.imageFlowCreate, ImageFlowSaga.imageFlowCreate),
    takeLatest(ImageFlowActions.imageFlowDelete, ImageFlowSaga.imageFlowDelete),
    takeLatest(ImageFlowActions.imageFlowCommentCreate, ImageFlowSaga.imageFlowCommentCreate),
    takeLatest(ImageFlowActions.imageFlowLike, ImageFlowSaga.imageFlowLike),
    takeLatest(ImageFlowActions.imageFlowSeen, ImageFlowSaga.imageFlowSeen),
    takeLatest(ImageFlowActions.imageFlowRequest, ImageFlowSaga.imageFlowRequest),

    takeLatest(EconomyActions.newAgreement, EconomySaga.newAgreement),
    takeLatest(EconomyActions.updateAgreement, EconomySaga.updateAgreement),
    takeLatest(EconomyActions.respondAgreement, EconomySaga.respondAgreement),
    takeLatest(EconomyActions.respondAgreementUpdate, EconomySaga.respondAgreementUpdate),
    takeLatest(EconomyActions.endAgreement, EconomySaga.endAgreement),
    takeEvery(EconomyActions.seenAgreement, EconomySaga.seenAgreement),
    takeLatest(EconomyActions.archiveAgreement, EconomySaga.archiveAgreement),
    takeLatest(EconomyActions.archiveAgreementUpdate, EconomySaga.archiveAgreementUpdate),

    takeLatest(EconomyActions.newPurchase, EconomySaga.newPurchase),
    takeLatest(EconomyActions.updatePurchase, EconomySaga.updatePurchase),
    takeLatest(EconomyActions.deletePurchase, EconomySaga.deletePurchase),
    takeLatest(EconomyActions.restorePurchase, EconomySaga.restorePurchase),
    takeLatest(EconomyActions.disputePurchase, EconomySaga.disputePurchase),
    takeEvery(EconomyActions.seenPurchase, EconomySaga.seenPurchase),
    takeLatest(EconomyActions.archivePurchase, EconomySaga.archivePurchase),

    takeLatest(EconomyActions.newTransfer, EconomySaga.newTransfer),
    takeLatest(EconomyActions.updateTransfer, EconomySaga.updateTransfer),
    takeLatest(EconomyActions.deleteTransfer, EconomySaga.deleteTransfer),
    takeLatest(EconomyActions.restoreTransfer, EconomySaga.restoreTransfer),
    takeLatest(EconomyActions.disputeTransfer, EconomySaga.disputeTransfer),
    takeEvery(EconomyActions.seenTransfer, EconomySaga.seenTransfer),
    takeLatest(EconomyActions.archiveTransfer, EconomySaga.archiveTransfer),

    takeLatest(EconomyActions.updateEcoSettings, EconomySaga.updateSettings),
    
  ]);
}



// WEBPACK FOOTER //
// ./src/saga.ts